<div [innerHTML]="input"></div>

<ng-container *ngIf="flow === 'gkalgraaf'">
    <button (click)="gkalgraafyes()" mat-button>
        Ja
    </button>    
    <button (click)="gkalgraafno()" mat-button>
        Nee
    </button>
</ng-container>